import initVueApp from "@/core.js";
const component = require(`./../views/ProductV3.vue`).default;
initVueApp(component);
